// Backend Base Url
export const BACKEND_BASE_URL = "https://thebharatiyavidya.com";
// export const BACKEND_BASE_URL = "http://localhost:8000";
export const IMAGE_HOST = "https://storage.thebharatiyavidya.com";
// export const IMAGE_HOST = "http://192.168.0.101:1337";
// -----------------------
// MediaBase Url
export const PROJECT_MEDIA_FOLDER = "bv";
export const IMAGE_BASE_URL = IMAGE_HOST + "/" + PROJECT_MEDIA_FOLDER + "/";
// -----------------------
// SubPath
export const API_URL = BACKEND_BASE_URL + "/api";

// External Server File-Upload API
export const EX_FILE_UPLOAD = IMAGE_HOST + "/api/fileSave";
export const EX_FILE_DESTROY = IMAGE_HOST + "/api/fileDestroy";

// Location API
export const LOCATIONS = "locations?country_id=";

// File-Upload API
export const ALL_UPLOADED_FILE = "files/folder-wise";
export const FOLDERS = "files/folders";
export const FILES_BY_FOLDER = "files/by-folder";
export const FILE_UPLOAD = "files/multi_upload";
export const FILE_UPDATE = "files/update";
export const FILE_DESTROY = "files/delete";

// POP-UP API
export const ALL_POPUP = "popup";
export const POPUP_BY_ID = "popup/detail";
export const CREATE_POPUP = "popup/add";
export const EDIT_POPUP = "popup/update";
export const DELETE_POPUP = "popup/delete";

// Auth API
export const LOGIN = "login/staff";
export const LOGOUT = "logout";
export const DASH_DATA = "dashboard-data";

// User API
export const USER = "user/list";
export const STAFF = "user/staff";
export const USER_DETAIL = "user/detailById";
export const ADD_USER = "user/add";
export const EDIT_USER = "user/update";
export const DELETE_USER = "user/delete";

// Brand API
export const ALL_BRAND = "brand";
export const BRAND_BY_ID = "brand/detail";
export const CREATE_BRAND = "brand/add";
export const EDIT_BRAND = "brand/update";
export const DELETE_BRAND = "brand/delete";

// Unit API
export const ALL_UNIT = "unit";
export const UNIT_BY_ID = "unitByID";
export const CREATE_UNIT = "createUnit";
export const EDIT_UNIT = "updateUnit";
export const DELETE_UNIT = "deleteUnit";

// Category API
export const ALL_CATEGORY = "category/all-list";
export const CATEGORY_BY_ID = "category/detail";
export const CREATE_CATEGORY = "category/add";
export const EDIT_CATEGORY = "category/update";
export const DELETE_CATEGORY = "category/delete";

// Sub-Category API
export const ALL_SUB_CATEGORY = "subCategory";
export const SUB_CATEGORY_CAT_ID = "subCategory/by-cat-id";
export const SUB_CATEGORY_BY_ID = "subCategory/detail";
export const CREATE_SUB_CATEGORY = "subCategory/add";
export const EDIT_SUB_CATEGORY = "subCategory/update";
export const DELETE_SUB_CATEGORY = "subCategory/delete";

// Contacts API
export const ALL_CONTACTS = "contact";
export const DELETE_CONTACTS = "contact/destroy";

// Blog/News API
export const ALL_BLOG = "blog";
export const BLOG_BY_ID = "blog/detail";
export const CREATE_BLOG = "blog/create";
export const EDIT_BLOG = "blog/update";
export const DELETE_BLOG = "blog/destroy";

// Testimonial API
export const ALL_TESTIMONIAL = "client";
export const TESTIMONIAL_BY_ID = "client/detail";
export const CREATE_TESTIMONIAL = "client/add";
export const EDIT_TESTIMONIAL = "client/update";
export const DELETE_TESTIMONIAL = "client/delete";

// Dynamic Content  API
export const ALL_DYNAMIC_CONTENT = "dynamic-pages";
export const DYNAMIC_CONTENT_BY_ID = "dynamic-pages/detail";
export const CREATE_DYNAMIC_CONTENT = "dynamic-pages/add";
export const EDIT_DYNAMIC_CONTENT = "dynamic-pages/update";
export const DELETE_DYNAMIC_CONTENT = "dynamic-pages/delete";

// Slider-Banner  API
export const ALL_SLIDER = "slider";
export const SLIDER_BY_ID = "slider/detail";
export const CREATE_SLIDER = "slider/create";
export const EDIT_SLIDER = "slider/update";
export const DELETE_SLIDER = "slider/destroy";

// Product API
export const ALL_PRODUCT = "products/all";
export const ALL_INV_PRODUCT = "products/inventory-list";
export const PRODUCT_BY_ID = "products/detail-no-cart";
export const PRODUCT_QTY_MANAGE = "products/store";
export const CREATE_PRODUCT = "products/store";
export const EDIT_PRODUCT = "products/update";
export const DELETE_PRODUCT = "products/delete";

// Order API
export const ALL_ORDERS = "orders";
export const ORDER_DETAIL = "orders/by-order-id";
export const ORDER_STATUS_UPDATE = "orders/status-update";
export const ORDER_PAYMENT_UPDATE = "orders/payment-update";
export const ORDER_CANCEL_UPDATE = "orders/cancel-update";
export const ORDER_INVOICE = BACKEND_BASE_URL + "/order-pdf/";

// Setting API
export const CREATE_SETTING = "system-setting/manage";
export const SETTING = "system-setting";

// Wishlist API
export const USER_WISE_WISHLIST = "wishlist";
export const REMOVE_TO_WISHLIST = "deleteWishlist";
export const CLEAR_THE_WISHLIST = "clearTheWishlist";

// Hom-Package  API
export const ALL_HOMEPACKAGE = "homePackage";
export const HOMEPACKAGE_BY_ID = "homePackageByID";
export const CREATE_HOMEPACKAGE = "createHomePackage";
export const EDIT_HOMEPACKAGE = "updateHomePackage";
export const DELETE_HOMEPACKAGE = "deleteHomePackage";

// Coupon  API
export const ALL_COUPON = "coupon/all";
export const COUPON_BY_ID = "coupon/detail";
export const CREATE_COUPON = "coupon/add";
export const EDIT_COUPON = "coupon/update";
export const DELETE_COUPON = "coupon/delete";

// On-Boarding  API
export const ALL_ONBORDING = "onBoardings";
export const ONBORDING_BY_ID = "onBoardingByID";
export const CREATE_ONBORDING = "createOnBoarding";
export const EDIT_ONBORDING = "updateOnBoarding";
export const DELETE_ONBORDING = "deleteOnBoarding";

// Notification Content  API
export const ALL_NOTIFICATION = "notification";
export const CREATE_NOTIFICATION = "createNotification";
export const EDIT_NOTIFICATION = "updateNotification";
export const DELETE_NOTIFICATION = "deleteNotification";

// Cart API
export const USER_WISE_CART = "cart";
export const REMOVE_TO_CART = "deleteCart";
export const CLEAR_THE_CART = "clearUserCart";
